import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken } from '../../GlobalStateContainer/actions'


const EMULATION_MODE_QUOTES = false


/*
 * Quote Actions
 * 
 */

export function fetchQuotesList(dispatch) {
    let cmd = 'FETCH_QUOTES_LIST'

    if (EMULATION_ALL || EMULATION_MODE_QUOTES)

        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productBrickId: 1,
                            name: 'Species',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMDEX',
                            example: 'Oak'
                        },
                        {
                            productBrickId: 2,
                            name: 'Brand Name',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMMFG',
                            example: 'Bal'
                        },
                        {
                            productBrickId: 3,
                            name: 'Edge',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'Rounded',
                            example: 'Rounded'
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            var url = buildRequestUrl('QuoteRequests');
            axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchQuoteError(dispatch) {

    dispatch(
        {
            type: 'FETCH_QUOTE_ERROR',
        }
    )
}

export function fetchQuote(id) {
    let cmd = 'FETCH_QUOTE'

    if (EMULATION_ALL || EMULATION_MODE_QUOTES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('QuoteRequests/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorQuote(dispatch) {

    dispatch(
        {
            type: 'QUOTE_ERROR',
        }
    )
}
